import $http from '@/libs/axios'

class DiscountsAPIs {
  static async getDiscounts(branchId: number, queryString: any) {
    return (await $http.get(`/promotions/discounts/branch/${branchId}?${queryString}`)).data
  }
}

export default DiscountsAPIs
